import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-listados-index',
  templateUrl: './listados-index.component.html',
  styleUrls: ['./listados-index.component.scss']
})
export class ListadosIndexComponent {

  TipoUsuario = TipoUsuario;
  
  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
